export default {
    addEventListeners: function(){       
        // scroll to id from url hash
        if (window.location.hash !== '' && window.location.hash.charAt(1) != '&' && $(window.location.hash).length > 0) {
            $("html, body").animate({ scrollTop: $(window.location.hash).offset().top - 100 }, 1000);
        }

        // scroll to id if hash link clicked
        $('body').on('click', 'a', function(e){
            var href = $(this).attr('href');
            if (href === undefined) return true;
            if (href.charAt(0) == '#' && href.length > 1 && $(href).length && typeof $(this).attr('aria-expanded') !== 'undefined') {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: ($(href).offset().top - 13)
                }, 1000);
                return false;
            }
            return true;
        });
    }
};